'use strict';

var __makeTemplateObject =
  (void 0 && (void 0).__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', {
        value: raw,
      });
    } else {
      cooked.raw = raw;
    }

    return cooked;
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.generateBottomSpacing = exports.generateTopSpacing = exports.generateSpacing = void 0;

var styled_components_1 = require('styled-components');

var components_1 = require('../constants/components');

var generateSpacing = function generateSpacing(_a) {
  var spacing = _a.spacing,
    theme = _a.theme;

  if (spacing) {
    return styled_components_1.css(
      templateObject_1 ||
        (templateObject_1 = __makeTemplateObject(
          [
            '\n      @media screen and (min-width: ',
            'px) {\n        padding: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        padding: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        padding: ',
            'px;\n      }\n    ',
          ],
          [
            '\n      @media screen and (min-width: ',
            'px) {\n        padding: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        padding: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        padding: ',
            'px;\n      }\n    ',
          ]
        )),
      components_1.BREAKPOINTS.mobile_small,
      theme.spacing.spacingFull[components_1.BREAKPOINTS.mobile_small][spacing],
      components_1.BREAKPOINTS.mobile_large,
      theme.spacing.spacingFull[components_1.BREAKPOINTS.mobile_large][spacing],
      components_1.BREAKPOINTS.tablet_vertical_large,
      theme.spacing.spacingFull[components_1.BREAKPOINTS.tablet_vertical_large][spacing]
    );
  }

  return '';
};

exports.generateSpacing = generateSpacing;

var generateTopSpacing = function generateTopSpacing(_a) {
  var spacingTop = _a.spacingTop,
    theme = _a.theme;

  if (spacingTop) {
    return styled_components_1.css(
      templateObject_2 ||
        (templateObject_2 = __makeTemplateObject(
          [
            '\n      @media screen and (min-width: ',
            'px) {\n        margin-top: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        margin-top: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        margin-top: ',
            'px;\n      }\n    ',
          ],
          [
            '\n      @media screen and (min-width: ',
            'px) {\n        margin-top: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        margin-top: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        margin-top: ',
            'px;\n      }\n    ',
          ]
        )),
      components_1.BREAKPOINTS.mobile_small,
      theme.spacing.spacingVertical[components_1.BREAKPOINTS.mobile_small][spacingTop],
      components_1.BREAKPOINTS.mobile_large,
      theme.spacing.spacingVertical[components_1.BREAKPOINTS.mobile_large][spacingTop],
      components_1.BREAKPOINTS.desktop_small,
      theme.spacing.spacingVertical[components_1.BREAKPOINTS.desktop_small][spacingTop]
    );
  }

  return '';
};

exports.generateTopSpacing = generateTopSpacing;

var generateBottomSpacing = function generateBottomSpacing(_a) {
  var spacingBottom = _a.spacingBottom,
    theme = _a.theme;

  if (spacingBottom) {
    return styled_components_1.css(
      templateObject_3 ||
        (templateObject_3 = __makeTemplateObject(
          [
            '\n      @media screen and (min-width: ',
            'px) {\n        margin-bottom: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        margin-bottom: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        margin-bottom: ',
            'px;\n      }\n    ',
          ],
          [
            '\n      @media screen and (min-width: ',
            'px) {\n        margin-bottom: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        margin-bottom: ',
            'px;\n      }\n      @media screen and (min-width: ',
            'px) {\n        margin-bottom: ',
            'px;\n      }\n    ',
          ]
        )),
      components_1.BREAKPOINTS.mobile_small,
      theme.spacing.spacingVertical[components_1.BREAKPOINTS.mobile_small][spacingBottom],
      components_1.BREAKPOINTS.mobile_large,
      theme.spacing.spacingVertical[components_1.BREAKPOINTS.mobile_large][spacingBottom],
      components_1.BREAKPOINTS.desktop_small,
      theme.spacing.spacingVertical[components_1.BREAKPOINTS.desktop_small][spacingBottom]
    );
  }

  return '';
};

exports.generateBottomSpacing = generateBottomSpacing;
var templateObject_1, templateObject_2, templateObject_3;
